<div class="container">
  <div class="header">
    <div class="header__inner">
      <div class="header__day">
        {{ currentScrollTime | momentp: 'D MMM YY' | titlecase }}
      </div>
      <div class="header__timeline">
        <div #timeline class="header__timeline__times">
          <ng-container *ngFor="let time of times">
            <div class="header__timeline__times__time" [style.left]="time.offset - minOffset - timelineOffset + 'px'">
              {{ time.value }}
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div class="rows">
    <!-- Smart Apps Rows -->
    <ng-container *ngIf="shouldShowSmartApps">
      <div class="row" *ngFor="let app of localApps">
        <div class="channel">
          <div class="channel__inner">
            <div class="channel__name">{{ app.tvApp?.name }}</div>
          </div>
        </div>
        <div class="programs">
          <div class="program app-program htv-selectable htv-autoclick htv-force-direction" (click)="onAppClick(app)">
            <div class="program-inner">
              <img class="app-icon" [attr.src]="app.iconUrl" [attr.alt]="app.tvApp?.name" />
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Channel Rows -->
    <div class="row" *ngFor="let channel of channels">
      <div class="channel">
        <div class="channel__inner">
          <div class="channel__logo" *ngIf="shouldShowChannelIcons">
            <img [attr.src]="channel.logoUrl" [attr.alt]="channel.name" />
          </div>
          <div class="channel__name">{{ channel.id }} {{ channel.name }}</div>
        </div>
      </div>

      <!-- Programs with info available -->
      <div #programs class="programs" *ngIf="channelsIPG[channel.id].programs.length > 0">
        <ng-container *ngFor="let program of channelsIPG[channel.id].programs; let i = index">
          <div
            class="program htv-selectable htv-autoclick htv-force-direction {{
              channel.id === selectedChannel?.id && i === selectedProgramIndex ? 'htv-focus' : ''
            }}"
            [style.width]="program.width + 'px'"
            [style.left]="program.offset - minOffset + 'px'"
            (click)="onClick($event, channel, program, i)">
            <div class="program-inner">
              <span class="text-ellipsis" *ngIf="program.program">
                {{ program.program | programTitle: locale }}
              </span>
            </div>
          </div>
        </ng-container>
      </div>

      <!-- No programs message -->
      <div
        class="programs no-programs htv-selectable htv-autoclick htv-force-direction {{
          channel.id === selectedChannel?.id ? 'htv-focus' : ''
        }}"
        *ngIf="channelsIPG[channel.id].programs.length === 0"
        (click)="onNoProgramClick(channel)">
        <div class="no-program-message">{{ 'PAGES.IPG.NO_PROGRAM_INFO' | translate }}</div>
      </div>
    </div>
  </div>
</div>
